import React, { useState, ChangeEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faKey } from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import { resetPassword } from '../../store/actions/auth';
import TextInput from '../../components/TextInput';
import { checkProperties, checkFieldValidation } from '../../services/utilService';
import { useLocation } from 'react-router';
import queryString from 'query-string'
import { IFormState } from '../../shared/models/validations';
import { IResetPassword } from '../../shared/models/authModel';
import update from 'react-addons-update';

const ResetPassword = (props: any) => {
    const [resetPwdForm, setResetPwdForm] = useState<IFormState>({
        values: {
            newPassword: "",
            confirmPassword: ""
        },
        valid: false,
        errors: {},
        validations: {
            newPassword: {
                label: 'New Password',
                required: true,
                password: true,
            },
            confirmPassword: {
                label: "Confirm Password",
                required: true,
                passwordMatch: true
            }
        }
    });
    const params = queryString.parse(useLocation().search);
    const { errors, values } = resetPwdForm;

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const validations = resetPwdForm.validations;
        let error = '';
        let confirmPasswordError = '';
        if (Object.keys(validations).includes(name)) {
            let secondValue = null;
            if (name === 'confirmPassword') {
                secondValue = values.newPassword;
            }
            if (name === 'newPassword') {
                confirmPasswordError = checkFieldValidation(validations['confirmPassword'], values.confirmPassword, values.newPassword) || '';
            }
            error = checkFieldValidation(validations[name], value, secondValue) || '';
        }
        setResetPwdForm(update(resetPwdForm, {
            values: {
                [name]: { $set: value }
            },
            errors: {
                'confirmPassword': name === 'newPassword' ? { $set: confirmPasswordError } : { $set: '' },
                [name]: { $set: error }
            }
        }));
    }

    const checkFormValidation = () => {
        let errors: any = {};
        // type IValidation = keyof ILoginState;
        const validations = resetPwdForm.validations;
        Object.keys(validations).forEach((field: any) => {
            let secondValue = null;
            if (field === 'confirmPassword') {
                secondValue = values.newPassword;
            }
            errors[field] = checkFieldValidation(validations[field], resetPwdForm.values[field], secondValue);
        });
        return errors;
    }
    const resetPassword = async () => {
        const errors = await checkFormValidation();
        const form = {
            ...resetPwdForm,
            errors,
        }
        setResetPwdForm(form);
        const noError = checkProperties(form.errors);
        if (noError) {
            if (params && params.id && params.token) {
                const reqParams: IResetPassword = {
                    userID: params.id,
                    token: params.token,
                    newPassword : values.newPassword
                }
                const reset = await props.doResetPassword(reqParams);
                if (reset) {
                    props.history.push('/login');
                }
            }
        }
    }
    return (
        <div className="login-center">
            <div className="login-wrapper">
                <div className="login-top">
                    <img src="assets/images/logo.png" />
                </div>
                <div className="text-center">
                    <h3>Reset Password</h3>
                </div>
                <div className="login-content">
                    <form className="witt-form login-form">
                        <div className="form-group">
                            <FontAwesomeIcon icon={faKey} />
                            <TextInput
                                type="password"
                                placeholder="New Password"
                                value={values.newPassword}
                                name="newPassword"
                                error={errors.newPassword}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <FontAwesomeIcon icon={faKey} />
                            <TextInput
                                type="password"
                                placeholder="Confirm Password"
                                value={values.confirmPassword}
                                name="confirmPassword"
                                error={errors.confirmPassword}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="login-action text-center">
                            <button disabled={props.isLoading} type="submit" className="btn btn-primary w-100" onClick={() => resetPassword()}>Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    isLoading: state.common.isLoading
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    doResetPassword: bindActionCreators(resetPassword, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);